// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InputRadio_wrapper__lPqQH","input":"InputRadio_input__VJtF9","label":"InputRadio_label__ctpwU"};